import { useMutation } from "@tanstack/react-query";
import { useApi } from "~hooks/apiHooks/useApi";

export const useImport = () => {
  const request = useApi();

  return useMutation<unknown, Error, { file: File; startImporting: (fileName: string) => Promise<unknown> }>({
    mutationFn: async ({ file, startImporting }) => {
      const { data } = await request<{ data: [{ fileName: string; uploadUrl: string }] }>(`import/upload-url`);
      const uploadResponse = await fetch(data[0].uploadUrl, {
        method: "PUT",
        body: file,
        headers: {
          "Content-Type": file.type,
        },
      });
      if (!uploadResponse.ok) {
        throw new Error("Failed to upload file to pre-signed URL");
      }
      await startImporting(data[0].fileName);
    },
  });
};
